import {Component, Input, OnInit} from '@angular/core';
import {FormsModule} from "@angular/forms";
import {
  BaseComponent,
  WmsDialogBodyComponent,
  WmsDialogFooterComponent,
  WmsDialogHeaderComponent,
  WmsMessageComponent
} from "@wms/app/components";
import {DialogService, NotificationService} from "@wms/services";
import {CommonModule} from "@angular/common";
import {PrefabManager} from "@wms/page-workspace";
import {runtimeEventManager} from "@wm/core";

@Component({
  selector: 'wms-delete-prefab-from-project',
  standalone: true,
  templateUrl: './wms-delete-prefab-from-project.component.html',
  imports: [
    FormsModule,
    WmsDialogBodyComponent,
    WmsDialogFooterComponent,
    WmsDialogHeaderComponent,
    WmsMessageComponent,
    CommonModule
  ],
  styleUrls: ['./wms-delete-prefab-from-project.component.less']
})
export class WmsDeletePrefabFromProjectComponent extends BaseComponent implements OnInit {
  @Input() dialogParams: any;
  title: string;
  dialogMessage: string;
  message: {type: string, caption: string} | null;
  processing: boolean;
  disableOk: boolean;
  pages: any[];

  constructor(private dialogService: DialogService, private prefabManager: PrefabManager, private notificationService: NotificationService) {
    super();
  }

  ngOnInit() {
    this.title          = 'TITLE_DELETE_PREFAB_FROM_PROJECT';
    this.dialogMessage  = this.locale.MESSAGE_DELETE_PREFAB_FROM_PROJECT.replace("${0}", this.dialogParams.prefabData.name);
    this.pages          = [];
    this.disableOk      = false;
    this.processing     = false;
    this.message        = null;
  }

  closeModal() {
    this.dialogService.close('deletePrefabFromProjectDialog');
  }

  onDeleteSuccess() {
    this.prefabManager.deRegisterPrefab(this.dialogParams.projectId, this.dialogParams.prefabData.name).then(response => {
      this.processing = false;
      this.disableOk  = false;
      runtimeEventManager.emit('load-prefabs');
      this.closeModal();
      this.notificationService.show('success', this.locale.MESSAGE_SUCCESS_TITLE, this.locale.MESSAGE_SUCCESS_DELETE_PREFAB);
    }, error => {
      this.processing = false;
      this.message    = { type: 'error', caption: error.message };
      let errObj      = error.error.errors.error[0];
      if (errObj.messageKey === 'com.wavemaker.platform.project$PrefabUsedInPages') {
        this.message        = {type: 'error', caption: this.locale.MESSAGE_FAILURE_DELETE_PREFAB_1};
        this.dialogMessage  = this.locale.MESSAGE_FAILURE_DELETE_PREFAB_2.replace("${0}", this.dialogParams.prefabData.name);
        this.pages          = errObj.parameters[1].replace(/^\[|\]$/g, '').split(',');
      }
    });
  }

  deletePrefabFromProject() {
    this.message = {
      type: 'loading', caption: this.locale.MESSAGE_DELETE_MESSAGE_PREFAB
    };
    this.processing = true;
    this.disableOk  = true;

    this.eventManager.emitPageSave(false);
    this.onDeleteSuccess();
    this.prefabManager.reloadPrefabs = true;
  }
}
